module.exports = __webpack_public_path__ + "img/mind_skeleton_19.e1c7adef.png";